// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root___mszq","footer":"ModalCreateQualiphyProcedure_footer__3sg6x","additionData":"ModalCreateQualiphyProcedure_additionData__3_dNO"};